import { render } from "./robot.html?vue&type=template&id=e1f382d0&scoped=true&ts=true"
import script from "./robot.ts?vue&type=script&lang=ts"
export * from "./robot.ts?vue&type=script&lang=ts"

import "./robot.scss?vue&type=style&index=0&id=e1f382d0&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f382d0"]])

export default __exports__